avisos.component('avisos.avisosModalComponent', {
    templateUrl: 'avisos/avisosModal/avisosModal.html',
    controller: 'avisos.avisosModalController',
    controllerAs: '$modal',
    bindings: { config: '=' }
});

avisos.controller('avisos.avisosModalController', ['$scope', 'coreLanguage', 'coreFb', '$filter', function($scope, $text, $fb, $filter) {
    const $ctrl = this;
    $scope.$text = $text;

    const formErrorsDefault = {
        titulo:{},
        produto:{}
    };

    $ctrl.close=()=>{
        $ctrl.config.show = false;
        $ctrl.formErrors = formErrorsDefault;
    };

    $ctrl.onBlur = (field) => {
        if(!$ctrl.formErrors){ $ctrl.formErrors = angular.copy(formErrorsDefault); }

        $ctrl.formErrors[field] = {
            field: !$scope.formContato[field].$valid,
            hint: !$scope.formContato[field].$valid
        };
    };

    $ctrl.validateForm=()=>{
        if($scope.formContato.$valid){
            $ctrl.config.confirm();
        }else{
            Object.keys(formErrorsDefault).forEach(key=>{ $ctrl.onBlur(key); });
        }
    };

    $ctrl.uploadBanner=(event)=>{
        const file = event.target.files[0]
        const ext = file.name.split('.').pop();

        if (!['png', 'jpg', 'jpeg', 'webp', 'svg'].includes(ext.toLowerCase())) {
            return
        }

        $ctrl.loadingFile=true;

        $fb.storage.upload(`/banners/${$ctrl.config.dados.produto}`, event.target.files[0]).then(url => {
            $fb.db.update($ctrl.config.dados.docPath, {imgUrl: url});
            $ctrl.config.dados.imgUrl = url
            $ctrl.loadingFile=false;
        })
    };

    $scope.$watch('$modal.config.show', (newValue) => {
        if(newValue){ 
            const hasProduto = $filter('filter')($ctrl.config.options, {id: $ctrl.config.dados.idProduto});
            $ctrl.selectedProduto = hasProduto[0] ?? null;
        }
    });

    $ctrl.$onInit=()=>{
        $ctrl.idUsuario = $fb.auth.getIdToken().claims.idUsuario;
    }

}]);